// bernie
import { ClientFactories, Store } from 'bernie-core';
import { NOOP_LOGGER } from 'bernie-logger';

// data
import {
  IndustrySource,
  LegalSource,
  ProductSource,
  ProgramSource,
  PzSource,
  PzCampaignSource,
  UserAuthSource,
  UserSource,
} from '../sources';
import {
  CaptchaStore,
  IndustryStore,
  LegalStore,
  LinkStore,
  ProductStore,
  ProgramStore,
  QuicklinkStore,
  UserAuthStore,
  UserStore,
  PzStore,
  PzCampaignStore,
} from '.';

export const stores: ClientFactories = {
  captcha: (): Store => new CaptchaStore(),
  industries: (): Store => new IndustryStore(new IndustrySource(), {}, NOOP_LOGGER),
  legal: (): Store => new LegalStore(new LegalSource({})),
  link: (): Store => new LinkStore(new LinkStore({}, NOOP_LOGGER)),
  products: (): Store => new ProductStore(new ProductSource({}), {}, NOOP_LOGGER),
  programs: (): Store => new ProgramStore(new ProgramSource([]), {}, NOOP_LOGGER),
  quicklinks: (): Store => new QuicklinkStore({}, NOOP_LOGGER),
  user: (): Store => new UserStore(new UserSource(), {}, NOOP_LOGGER),
  userAuth: (): Store => new UserAuthStore(new UserAuthSource(null), {}, NOOP_LOGGER),
  pzStore: (): Store => new PzStore(new PzSource(), {}, NOOP_LOGGER),
  pzCampaignStore: (): Store => new PzCampaignStore(new PzCampaignSource(), {}, NOOP_LOGGER),
};
